<template>
  <el-card class="delay-card">
    <el-row type="flex"
            slot="header"
            class="header"
            align="middle"
            justify="space-between">
      <el-col :span="12">
        <div>
          <span class="header-title">{{curDelayInfo.DELAYTYPENAME}}</span>
          <span class="header-applyType">{{curDelayInfo.APPROVALSTATENAME}}</span>
        </div>
      </el-col>
      <el-col :span="12">
        <span style="float:right">逾期时间：{{curDelayInfo.ORIGINENDTIME|timeFormater}}</span>
      </el-col>
    </el-row>
    <div class="card-content">
      <el-row>
        <span class="title">任务名称：{{curDelayInfo.TASKNAME}}</span>
      </el-row>
      <el-row :gutter="5">
        <el-col :span="6">
          <div>
            <span class="column-label">创建人：</span>
            <span class="column-value">{{curDelayInfo.MAINCREATEUSERNAME}}</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div>
            <span class="column-label">创建时间：</span>
            <span class="column-value">{{curDelayInfo.MAINCREATETIME|timeFormater}}</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div>
            <span class="column-label">任务编号：</span>
            <span class="column-value">{{curDelayInfo.MAININSTANCE}}</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div>
            <span class="column-label">申请人：</span>
            <span class="column-value">{{curDelayInfo.CREATEUSERNAME}}</span>
          </div>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-row :gutter="5">
        <span class="column-content"> 申请内容：{{curDelayInfo.MEMO}} </span>
      </el-row>
      <el-row :gutter="5"
              type="flex">
        <el-col :span="4">
          <div>
            <span class="column-label">延期时长：</span>
            <span class="column-value">{{curDelayInfo|delayFormater}}</span>
          </div>
        </el-col>
        <el-col :span="5">
          <div>
            <span class="column-label">申请时间：</span>
            <span class="column-value">{{curDelayInfo.CREATETIME|timeFormater}}</span>
          </div>
        </el-col>
        <el-col :span="4">
          <div>
            <span class="column-label">审核人：</span>
            <span class="column-value">{{curDelayInfo.APPROVALUSERNAME}}</span>
          </div>
        </el-col>
        <el-col :span="4"
                v-show="curDelayInfo.ISAPPROVAL!==null">
          <div>
            <span class="column-label">确认延期时长：</span>
            <span class="column-value">{{curDelayInfo|approveDelayFormater}}</span>
          </div>
        </el-col>
        <el-col :span="5"
                v-show="curDelayInfo.ISAPPROVAL!==null">
          <div>
            <span class="column-label">审批时间：</span>
            <span class="column-value">{{curDelayInfo.APPROVALTIME|timeFormater}}</span>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="5"
              v-show="curDelayInfo.ISAPPROVAL!==null">
        <span class="column-content"> 审核内容：{{curDelayInfo.APPROVALMEMO}} </span>
      </el-row>
      <el-row type="flex"
              v-show="showApproveButton()"
              justify="end">
        <el-button type="primary"
                   size="mini"
                   @click="passApply">审核</el-button>
      </el-row>
    </div>
    <DelayApprove ref="approveControl"
                  @refershSource="refershSource"></DelayApprove>
  </el-card>
</template>

<script>
import DelayApprove from "./DelayApprove.vue";
import { getToken } from "./../../../util/auth";
import { ApprovalTaskDelay } from "@/api/modules/basicData/task";
const cookieUser = getToken();
export default {
  props: {
    curDelayInfo: {
      type: Object,
      default: {}
    }
  },
  components: {
    DelayApprove
  },
  filters: {
    applyFormater: function(value) {
      if (value) {
        if (value.length > 0) return "待审核";
      }
      return "待申请";
    },

    delayFormater: function(value) {
      let delayTimeName = "";
      switch (value.DELAYUNIT) {
        case 0:
          delayTimeName = value.DELAYNUM + "分钟";
          break;
        case 1:
          delayTimeName = value.DELAYNUM + "小时";
          break;
        case 2:
          delayTimeName = value.DELAYNUM + "天";
          break;
        default:
          break;
      }
      return delayTimeName;
    },
    approveDelayFormater: function(value) {
      let delayTimeName = "";
      switch (value.APPROVALDELAYUNIT) {
        case 0:
          delayTimeName = value.APPROVALDELAYNUM + "分钟";
          break;
        case 1:
          delayTimeName = value.APPROVALDELAYNUM + "小时";
          break;
        case 2:
          delayTimeName = value.APPROVALDELAYNUM + "天";
          break;
        default:
          break;
      }
      return delayTimeName;
    }
  },
  methods: {
    refershSource() {
      this.$emit("refershSource");
    },
    //TODO:不通过
    rejectApply() {
      this.$prompt("不通过原因", "逾期审批", {
        confirmButtonText: "确认",
        cancelButtonText: "取消"
      }).then(({ value }) => {
        this.curDelayInfo.ISAPPROVAL = false;
        this.curDelayInfo.APPROVALMEMO = value;
        ApprovalTaskDelay(this.curDelayInfo).then(result => {
          if (result.ResultCode > 0) {
            this.refershSource();
            this.$message.success("保存成功");
          } else {
            this.$message.error(result.MsgInfo);
          }
        });
      });
    },
    //TODO:通过
    passApply() {
      this.$refs.approveControl.loadDelayInfo(this.curDelayInfo);
    },
    //显示审批按钮
    showApproveButton() {
      //只有需要审批，且没有审批过，同时审批人为当前人的才显示审批按钮
      console.log("curDelayInfo " + this.curDelayInfo.ISAPPROVAL);
      if (this.curDelayInfo) {
        if (
          this.curDelayInfo.APPROVALUSERID === cookieUser.userId &&
          this.curDelayInfo.ISAPPROVAL === null
        )
          return true;
      }
      return false;
    }
  }
};
</script>
<style scoped>
.delay-card .el-card__header {
  padding: 0 !important;
}
.delay-card .el-divider {
  margin: 12px 0 !important;
}
.delay-card .el-card__body {
  padding: 0 20px;
}
</style>
<style scoped>
.delay-card {
  margin-bottom: 10px;
}
.header {
  padding: 0 20px;
  height: 50px;
  font-size: 14px;
  background-color: #e1ebf7;
}

.title {
  font-size: 16px;
  line-height: 30px;
  text-align: left;
  max-height: 60px;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-weight: bold;
}
.header-title {
  font-weight: bold;
  font-size: 18px;
}
.header-applyType {
  color: orangered;
  font-size: 14px;
  margin: 0 10px;
}
.card-content {
  margin-top: 12px;
}
.card-content .el-row {
  margin-bottom: 8px;
}
.column-label {
  color: #999999;
  font-size: 14px;
}
.column-value {
  font-size: 14px;
}
.column-content {
  font-size: 16px;
  font-weight: bold;
}
</style>